import {
  signUp as apiSignUp
} from 'api/user'

export const signUp = data => async dispatch => {
  return dispatch(apiSignUp(data))
}
